import {ord, ordString} from 'fp-ts/lib/Ord';
import {sortBy} from 'fp-ts/lib/Array';

const orderByElementKey = ord.contramap(ordString, (element: JSX.Element) => element.key as string);
const sortElementsByKey = sortBy([orderByElementKey]);

export default sortElementsByKey;
